import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false, name: 'leadingZero' })
export class LeadingZeroPipe implements PipeTransform {
  transform(value: number): string {
    // Convert the number to a string and add a leading zero if it's a single-digit number
    return value < 10 ? '0' + value.toString() : value.toString();
  }
}
